import axios from "axios"
import { baseURL, config, requestID } from "../../common/utils"





export const getDepartmentInventory = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const res = await axios.post(`${baseURL}Geacloud_ItemsRequisitions/getDepartmentItems`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};


export const getWarehouseStocks = async () => {
    const data = {
        requestID: requestID()
    };
    try {
        const res = await axios.post(`${baseURL}Geacloud_ItemsRequisitions/getWarehouseStocks`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};

export const getMyDepartmentRequests = async () => {

    const payload = {
        requestID: requestID()
    }

    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getMyDepartmentRequests`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
 
export const getDepartmentRequests = async (filters) => {

    const payload = {
        requestID: requestID(),...filters
    }

    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getMyDepartmentRequests`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
 
export const addDepartmentRequest = async (payload) => {

    const data = {
        requestID: requestID(),...payload
    };

    try {
        const res = await axios.post(`${baseURL}Geacloud_ItemsRequisitions/createItemRequisition`, data, config)
        console.log(res)
        return res.data
    } catch (error) {

   return error
    }
}



export const addWarehouseRequest = async (payload) => {

    const data = {
        requestID: requestID(),...payload
    };

    try {
        const res = await axios.post(`${baseURL}Geacloud_ItemsRequisitions/createPurchaseRequisitionItem`, data, config)
        console.log(res)
        return res.data
    } catch (error) {

   return error
    }
}

export const getMyPurchaseOrderRequests = async (queryParams) => {

    const payload = {
        requestID: requestID(),...queryParams
    }
    console.log({payload})
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getMyPurchaseOrderRequests`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
 
export const getMyPurchaseOrderRequestsByStage = async (queryParams) => {

    const payload = {
        requestID: requestID(),...queryParams
    }


    console.log({payload})
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getMyPurchaseOrderRequestsByStage`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}

export const getAuditPurchaseOrderRequests = async (queryParams) => {

    const payload = {
        requestID: requestID(),...queryParams
    }


    console.log({payload})
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getAuditPurchaseOrderRequests`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}



 
export const getAllPurchaseOrderRequests = async (filters) => {

    const payload = {
        requestID: requestID(),...filters
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getAllPurchaseOrderRequests`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getVendorsPurchaseOrderRequests = async (filters) => {

    const payload = {
        requestID: requestID(),...filters
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_Purchase_Orders/purchase_orders`, payload, config)
        console.log({res})
        return res
    } catch (error) {
        console.error(error)
    }
}
 


export const updateRequestStatus = async (data) => {

    const payload = {
        requestID: requestID(),...data
        // payload: data
    }

    try {
        const res = await axios.post(`${baseURL}Geacloud_ItemsRequisitions/updateApproval`, payload, config)
        console.log('heysdhgfkhdgfkhs',res)
        return res.data
    } catch (error) {
        console.error(error)
    }
}




export const getDepartmentsList = async () => {

    const payload = {
        requestID: requestID(),
    }

    try {
        const res = await axios.post(`${baseURL}Geacloud_ItemsRequisitions/getAllDepartment`, payload, config)
        console.log(res)
        return res.data
    } catch (error) {

        return error
    }
}

export const getStocksTransfer = async () => {

    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getStocksTransfer`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}


export const addBarRequest = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/addBarRequest`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}
export const getMyBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getMyBarRequestsWithItems`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}

export const getPendingBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getPendingBarRequestsWithItems`, payload, config)
        return res
    } catch (error) {

        return error
    }
}

export const getAllBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getAllBarRequestsWithItems`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}



export const updateCMDApproval = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/updateApproval`, payload, config)
        
        return res
    } catch (error) {

        return error
    }
}
export const updateApprovalStatus = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/updateApprovalStatus`, payload, config)
        
        return res
    } catch (error) {

        return error
    }
}
export const updateApproval = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }
    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/updateApproval`, payload, config)
        
        return res
    } catch (error) {

        return error
    }
}
export const getCMDApprovedOrders = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }
    try {
        const res =await axios.post(`${baseURL}Geacloud_ItemsRequisitions/getCmdApprovedPurchaseOrderRequests`, payload, config)
        console.log("cmd approve", res)
        return res
    } catch (error) {

        return error
    }
}
export const getPendingCMDApprovals = async (data) => {

    // const payload = {
    //     requestID: requestID(),
    //     data: data
    // }
      const payload = {
        requestID: requestID(),...data
    }

    try {
        const res = axios.post(`${baseURL}Geacloud_ItemsRequisitions/getCmdPendingPurchaseOrderRequests`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}



//   getPendingCMDApprovals, 
//   getCMDApprovedOrders, 
//   updateCMDApproval,